import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { EditProvider } from "@/components/EditContext";
import SplashScreen from "@/components/SplashScreen";
import BriefFlow from "@/components/BriefFlow";
import StoryFlow from "@/components/StoryFlow";
import AdminUpload from "@/components/AdminUpload";
import PhotoWall from "@/components/PhotoWall";
import { PhotoWidget } from "@/components/PhotoWidget";
// import ChatBot from "@/components/ChatBot"; // Commented out per user request - easy to re-enable

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  // const location = useLocation();
  // const showChat = location.pathname !== "/" && location.pathname !== "/admin";

  return (
    <div className="grain-overlay">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/breve" element={<BriefFlow />} />
        <Route path="/storia" element={<StoryFlow />} />
        <Route path="/foto" element={<PhotoWall />} />
        <Route path="/admin" element={<AdminUpload />} />
      </Routes>
      <PhotoWidget />
      {/* ChatBot widget commented out per user request - uncomment to re-enable
      {showChat && <ChatBot />}
      */}
    </div>
  );
}

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          style: { fontFamily: "'Outfit', sans-serif", background: "#F9F8F6", border: "1px solid #E6DFD3", color: "#222421" }
        }}
      />
      <BrowserRouter>
        <EditProvider>
          <AppContent />
        </EditProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
